import React from 'react'
import Mainpage from './components/Mainpage/Mainpage'
import Navbar from './components/Navbar/Navbar'

const App = () => {
  return (
    <> 
    <Navbar/>
    <Mainpage/>
    </>
  )
}

export default App